<template>
  <v-card
    flat
    class="pa-0"
  >
    <v-card-title
        class="orange--text text--darken-2"
    >
      {{ $t('blob.suggestions.slider.title')}}
    </v-card-title>
    <v-divider class="orange darken-2"></v-divider>
    <v-card-text class="pa-0">
      <Carousel
        :perPageCustom="[[480, 1], [768, 3]]"
        :scrollPerPage="true"
      >
        <slide
            v-for="blob in blobs"
            :key="blob.id"
        >
          <v-container>
            <Details :blob="blob"></Details>
          </v-container>
        </slide>
      </Carousel>
    </v-card-text>
  </v-card>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
import { blobSuggestionLoader } from '../../../mixins/blobSuggestionLoader'
import Details from '@/components/Blob/Suggestion/Details'

export default {
  name: 'BlobSuggestionCarousel',
  components: { Details, Carousel, Slide },
  mixins: [blobSuggestionLoader]
}
</script>

<style scoped>

</style>
